export function normalizePlanNameKey(nombre) {
  return String(nombre || '').trim().replace(/^gym\d+::gym::/i, '');
}

export function planMatchesInviteAllowList(plan, allowedNames) {
  if (!plan || !Array.isArray(allowedNames) || !allowedNames.length) return false;
  const nombre = String(plan.nombre || '');
  const base = normalizePlanNameKey(nombre);
  return allowedNames.some((raw) => {
    const allowed = String(raw || '');
    return allowed === nombre || normalizePlanNameKey(allowed) === base;
  });
}
